export default "__VITE_ASSET__BSNAkngS__"